import './CompanyProfilePage.css';

import React, { useContext } from 'react';
import { Box } from '@mui/material';
import useB2BTranslation from '../../b2b-common/hooks/useB2BTranslation';
import Banner from '../../b2b-common/Banner';
import useGetOrganizationInfo from '../hooks/useGetOrganizationInfo';
import useGetActiveLicense from '../hooks/useGetActiveLicense';
import B2BElementsExplorerInMemory from '../../b2b-common/B2BElementsExplorerInMemory';
import ProductCard from '../components/products/ProductCard';
import { toLocaleDateTime } from '../../b2b-common/helpers';
import FieldText from '../../b2b-common/FieldText';
import B2BImageCard from '../../b2b-common/B2BImageCard';
import { uploadOrganizationImage } from '../../../services/b2b-users-apiService';
import { LoginContext } from '../../../App';
import { B2BContentContext } from '../../layout/Layout';
import { showNotification } from '../../b2b-common/Notification';

const CompanyProfilePage = () => {
    const { loginData } = useContext(LoginContext);
    const { setNotification } = useContext(B2BContentContext);
    const { t } = useB2BTranslation('b2b-users');
    const { organizationName, organizationImage } = useGetOrganizationInfo();
    const { activeLicenseData, isFetching } = useGetActiveLicense();

    if (isFetching) {
        return (
            <Box className={'company-profile-page'} width={'100%'} height={'100%'} display={'flex'} justifyContent={'center'} alignItems={'center'} >
                {t('Loading...')}
            </Box>
        );
    }

    const products = activeLicenseData?.products || [];

    const handleNewOrganizationImage = (file) => {
        if (file) {
            try {
                uploadOrganizationImage(loginData?.loggedOrganizationUuid, file, loginData?.accessToken);
                showNotification(setNotification, t('Organization image updated'), 'success', 3000);
            } catch (error) {
                console.error('Error uploading the organization image:', error);
                showNotification(setNotification, t('Error uploading the organization image'), 'error', 5000);
            }
        }
    }

    return (
        <Box className={'company-profile-page'} width={'100%'} height={'100%'} display={'flex'} flexDirection={'column'} gap={3} >
            <Banner message={organizationName} underline={false} headingLevel='h1' />
            <Banner message={t('Organization logo and active license')} underline={false} headingLevel='h2' />
            <Box className={'company-logo-and-license'} display={'flex'} flexDirection={'row'} gap={4} >
                <Box className={'company-logo'} width={'200px'} height={'200px'} >
                    <B2BImageCard imagePath={organizationImage}
                        showChangeButton={true}
                        requestChangeConfirmation={true}
                        onChange={handleNewOrganizationImage}
                        synchrousUpdate={true}
                    />
                </Box>
                <Box className={'company-license'} width={'calc(90% - 200px)'} height={'200px'} overflow={'auto'} pl={5} display={'flex'} flexDirection={'column'} gap={1} >
                    <FieldText label={t('License ID')} labelAlign='left'  text={activeLicenseData?.licenseCode} textAlign='left'/>
                    <FieldText label={t('Start Date')} labelAlign='left' text={toLocaleDateTime(activeLicenseData?.startDate)} textAlign='left' />
                    <FieldText label={t('End Date')} labelAlign='left' text={toLocaleDateTime(activeLicenseData?.endDate)} textAlign='left' />
                </Box>
            </Box>
            <Banner message={t('Products included')} underline={false} headingLevel='h2' />
            <B2BElementsExplorerInMemory
                elementsData={{ content: products }}
                className={'company-profile-products'}
                ElementComponent={ProductCard}
                elementComponentPropName={'product'}
                currentPage={1}
                numRows={4}
                // numRows={products ? products.length : 0}
            />
        </Box>
    );
};

export default CompanyProfilePage;